import CategoryList from 'components/categoryList/typeAd';
import Header from 'modules/header/farm/main';

const AddAdsPage = () => {
  return (
    <>
      <Header title="حجره" />
      <div className="mx-3 mt-5">
        <CategoryList
          title="نوع آگهی را انتخاب کنید"
          route="/farm/add-ad/select-cultivation"
          appType="farm"
        />
      </div>
    </>
  );
};

export default AddAdsPage;
